/**
 * Default options for Owl Carousel
 */
const owlCarouselOptions = {
	items:           1,
	margin:          0,
	autoplay:        0,
	autoplayTimeout: 5000,
	slideBy:         1,
	loop:            0,
	nav:             0,
	smartSpeed:      1000,
	dots:            0
}


/**
 * Fancybox custom elements
 */
const fancyData = {
	fancyDefaultOptions: {
		autoFocus: false,
		lang: 'ru',
		i18n: {
			en: {
				CLOSE: 'Close',
				NEXT: 'Next',
				PREV: 'Previous',
				ERROR: 'The requested content cannot be loaded. <br/> Please try again later.',
				PLAY_START: 'Start slideshow',
				PLAY_STOP: 'Pause slideshow',
				FULL_SCREEN: 'Full screen',
				THUMBS: 'Thumbnails',
				DOWNLOAD: 'Download',
				SHARE: 'Share',
				ZOOM: 'Zoom'
			},
			ru: {
				CLOSE: 'Закрыть',
				DOWNLOAD: 'Скачать',
				ERROR: 'Запрашиваемый контент не может быть загружен. <br/> Пожалуйста, попробуйте позже.',
				FULL_SCREEN: 'На весь экран',
				NEXT: 'Вперед',
				PLAY_START: 'Начать слайдшоу',
				PLAY_STOP: 'Остановить слайдшоу',
				PREV: 'Назад',
				SHARE: 'Поделиться',
				THUMBS: 'Миниатюры',
				ZOOM: 'Увеличить'
			}
		}
	},
	fancyCustomElements: []
}

export {
	owlCarouselOptions,
	fancyData,
}
